var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72524 0.124756C5.39818 0.124756 3.51172 2.01122 3.51172 4.33829C3.51172 6.66535 5.39818 8.5518 7.72524 8.5518C10.0523 8.5518 11.9388 6.66535 11.9388 4.33829C11.9388 2.01122 10.0523 0.124756 7.72524 0.124756Z",
    fill: "#4A9A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14416 10.6099C8.38107 10.2659 8.15325 9.7413 7.73558 9.74121H6.61412C3.15109 9.74121 0.34375 12.5485 0.34375 16.0116C0.34375 17.4248 1.48941 18.5705 2.90264 18.5705H7.79755C8.22028 18.5705 8.44763 18.0326 8.20228 17.6884C7.48206 16.6786 7.05841 15.4426 7.05841 14.1077C7.05841 12.8092 7.45933 11.6042 8.14416 10.6099Z",
    fill: "#4A9A93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14.1077C18 16.7407 15.8655 18.8753 13.2324 18.8753C10.5994 18.8753 8.46484 16.7407 8.46484 14.1077C8.46484 11.4746 10.5994 9.34009 13.2324 9.34009C15.8655 9.34009 18 11.4746 18 14.1077ZM15.9606 12.2961C16.2528 12.552 16.2822 12.9962 16.0264 13.2884L13.618 16.0381C13.1695 16.5501 12.3807 16.5737 11.9025 16.0893L10.55 14.7195C10.2772 14.4432 10.28 13.998 10.5564 13.7252C10.8327 13.4524 11.2779 13.4552 11.5507 13.7315L12.372 14.5633C12.5632 14.757 12.8788 14.7476 13.0582 14.5428L14.9685 12.3618C15.2243 12.0697 15.6686 12.0403 15.9606 12.2961Z",
    fill: "#4A9A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUser);
export default __webpack_public_path__ + "static/media/active-user.793b7146e1d31ea844701ee5fb8d3a1c.svg";
export { ForwardRef as ReactComponent };